class ProductBadgeManager {
  constructor() {
    this.init();
  }

  init() {
    // Event-Listener für Varianten-Wechsel auf Collection-Seiten
    document.addEventListener('change', (e) => {
      if (e.target.matches('select[name="id"], input[name="id"]')) {
        this.updateProductBadge(e.target);
      }
    });
  }

  async updateProductBadge(element) {
    const productCard = element.closest('.card-wrapper, .product-card-wrapper');
    if (!productCard) return;

    const productHandle = this.getProductHandle(productCard);
    const variantId = element.value;

    try {
      const response = await fetch(`/products/${productHandle}.js`);
      const product = await response.json();
      const variant = product.variants.find(v => v.id == variantId);
      
      this.renderBadge(productCard, variant);
    } catch (error) {
      console.error('Badge update error:', error);
    }
  }

  renderBadge(card, variant) {
    // WICHTIG: Shopifys öffentliches /products/{handle}.js liefert KEIN
    // inventory_quantity / inventory_policy (beide undefined). Damit lässt sich der
    // Backorder-Status clientseitig NICHT bestimmen. Ohne belastbare Daten dürfen wir die
    // serverseitig (Liquid) korrekt gerenderten Badges NICHT anfassen — sonst berechnet
    // shouldShowBadge fälschlich false und der Badge wird nach jedem Varianten-„change"
    // entfernt (= das beobachtete kurze Aufflackern und dann Verschwinden).
    if (typeof variant.inventory_quantity !== 'number') return;
    const existingBadge = card.querySelector('.card__badge--backorder-hangtag');
    const shouldShowBadge = variant.inventory_management === 'shopify' && 
                           variant.inventory_policy === 'continue' && 
                           variant.inventory_quantity <= 0;

    if (shouldShowBadge && !existingBadge) {
      const mediaContainer = card.querySelector('.card__media');
      const badge = document.createElement('div');
      badge.className = 'card__badge card__badge--backorder-hangtag';
      badge.innerHTML = `
        <span class="hangtag__icon">⚠️</span>
        <span class="hangtag__text">Vorbestellung</span>
      `;
      mediaContainer.appendChild(badge);
    } else if (!shouldShowBadge && existingBadge) {
      existingBadge.remove();
    }
  }

  getProductHandle(card) {
    const link = card.querySelector('a[href*="/products/"]');
    return link ? link.href.split('/products/')[1].split('?')[0] : null;
  }
}

new ProductBadgeManager();